import { render, staticRenderFns } from "./VolunteerMatchResults.vue?vue&type=template&id=24acc8bf"
import script from "./VolunteerMatchResults.vue?vue&type=script&lang=ts"
export * from "./VolunteerMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerMatchResults.vue?vue&type=style&index=0&id=24acc8bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports